import React, { createContext, useState } from 'react';

export const ShowContext = createContext();

export const ShowContextProvider = ({ children }) => {
    const [isShow, setIsSHow] = useState(false);
    const [imageDescription, setimageDescription] = useState({
        'title': "",
        'description': "",
        'dimensions': ""
    })
    return (
        <ShowContext.Provider value={{ isShow, setIsSHow, imageDescription, setimageDescription }}>
            {children}
        </ShowContext.Provider>
    )
}


// WEBPACK FOOTER //
// ./src/context/showContext.js